import { Injectable, OnInit } from '@angular/core';

import { environment } from 'src/environments/environment';
import { ServicioGeneral } from '../servicio-general.service';
import { imagenes } from './constantes';

@Injectable({
  providedIn: 'root'

})
export class PdfgenerateServiceEmvs {

  constructor(
    private _servicioGeneral: ServicioGeneral
  ) { }

  usuario: object = {};
  formularioPuestos: any;
  proteccionDatos: object[] = [];
  lopd = "";
  consultaDatos: object[] = [];

  bodyDataUser: object[] = [];
  bodyDirecciones: object[] = [];
  bodyForms: object[] = [];

  formRepresentante: any = {};
  formCircunstancias: any = {};
  formUnidadFamiliar: any = {};
  formDistritos: any = {};
  formVulnerabilidad: any = {};
  formFicheros: any[] = [];
  formAutorizacion: any = {};
  formConsulta: any = {};
  formExponeSolicita: any = {};
  formRepresentanteReducido: any = {};
  mapDocumentos: any[] = [];
  municipioNombre: string = "";
  pageSize: 'A4';

  pdf: string = '';

  public async generatePDF3Emvs(formularioPuestos, proteccionDatos, currentUser, lopd): Promise<{}> {
    this.formularioPuestos = [];
    this.proteccionDatos = [];
    this.bodyDataUser = [];
    this.bodyDirecciones = [];
    this.usuario = {};
    this.formularioPuestos = formularioPuestos;
    this.proteccionDatos = proteccionDatos;
    this.usuario = currentUser;
    this.lopd = lopd;


    return this.objetPDF();
  }

  public async generatePDF2Emvs(mapDocumentos, currentUser, formRepresentante, formCircunstancias, formUnidadFamiliar, formDistritos, formVulnerabilidad, formFicheros, formAutorizacion, formConsulta): Promise<{}> {
    this.bodyDataUser = [];
    this.bodyDirecciones = [];
    this.consultaDatos = [];
    this.usuario = {};
    this.formRepresentante = {};
    this.formCircunstancias = {};
    this.formUnidadFamiliar = {};
    this.formDistritos = {};
    this.formVulnerabilidad = {};
    this.formFicheros = [];
    this.formAutorizacion = {};
    this.formConsulta = {};
    this.mapDocumentos = mapDocumentos;

    this.usuario = currentUser;
    this.formRepresentante = formRepresentante;
    this.formCircunstancias = formCircunstancias;
    this.formUnidadFamiliar = formUnidadFamiliar;
    this.formDistritos = formDistritos;
    this.formVulnerabilidad = formVulnerabilidad;
    this.formFicheros = formFicheros;
    this.formAutorizacion = formAutorizacion;
    this.formConsulta = formConsulta;



    return this.objetPDFAnexo2();
  }

  public async generatePDF1Emvs(mapDocumentos, formRepresentanteReducido, formularioExponeSolicita, currentUser): Promise<{}> {
    this.formExponeSolicita = [];

    this.bodyDataUser = [];
    this.bodyDirecciones = [];
    this.usuario = {};

    this.formExponeSolicita = formularioExponeSolicita;
    this.formRepresentanteReducido = formRepresentanteReducido;
    this.usuario = currentUser;
    this.mapDocumentos = mapDocumentos;


    return this.objetPDFAnexo1();
  }

  /**
   * FUNCIONES DE GENERACIÓN DE PDF DINÁMICO
   * 
   */

  public objetPDF(): object {
    this.crearTablaUsuario();
    this.crearTablaDireccion();
    this.crearTablaLopd();
    return {
      //header:this.addlogo(),
      content: [
        this.addlogo(),
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1, 
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*', '*'],
            body: [
              [{ text: 'Datos personales', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],

              [{
                border: [true, false, false, true],
                stack: [
                  { text: 'Persona física', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDataUser,
                  },
                ]
              },
              {
                border: [false, false, true, true],
                stack: [
                  { text: 'Dirección del interesado', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDirecciones,
                  },
                ]
              }],
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*'],
            body: [
              [{ text: 'Puestos solicitados', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
              [{
                border: [true, true, true, true],
                stack: this.crearTablaPuestos(),
              }],
            ]
          },
        },
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*'],
            body: [
              [{ text: 'Documentos adjuntos', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
              [{
                border: [true, true, true, true],
                stack: this.crearTablaDocumentos(),
              }],
            ]
          },
        },
        {
          text: ' ',
        },

        // {
        //   table: {
        //     headerRows: 1,
        //     widths: ['*'],
        //     body: [
        //       [{ text: 'Ley orgánica de protección de datos', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
        //       [{
        //         border: [true, true, true, true],
        //         text: this.lopd, fontSize: 9
        //       }],
        //     ]
        //   },
        // }
      ],
      footer: this.footer_definition,
      styles: {
        tableHeader: {
          fontSize: 14,
        },
        bodyUser: {
          fontSize: 9,
          marginTop: 2,
        }
      }
    }
  }
  public objetPDFAnexo1(): object {
    this.crearTablaUsuario();
    this.crearTablaDireccion();
    this.crearTablaLopd();
    return {
      //header:this.addlogo(),
      content: [
        this.addlogo(),
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*', '*'],
            body: [
              [{ text: 'Datos interesado', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
              [{
                border: [true, false, false, true],
                stack: [
                  { text: 'Persona Física', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDataUser,
                  },
                ]
              },
              {
                border: [false, false, true, true],
                stack: [
                  { text: 'Dirección del interesado', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDirecciones,
                  },
                ]
              }],
            ]
          },
        },
        {
          text: ' ',
        },
        this.crearTablaRepresentanteReducido(),
        {
          text: ' ',
        },
        this.crearTablaExponeSolicita(),
        {
          text: ' ',
        },
        this.crearTablaDocumentosAdjuntos(),
      ],
      footer: this.footer_definition,
      styles: {
        tableHeader: {
          fontSize: 14,
        },
        bodyUser: {
          fontSize: 9,
          marginTop: 2,
        }
      }
    }
  }


  public objetPDFAnexo2(): object {
    this.crearTablaUsuario();
    this.crearTablaDireccion();

    return {
      //header:this.header_definition,
      content: [
        this.addlogo(),
        {
          text: ' ',
        },
        {
          table: {
            headerRows: 1,
            dontBreakRows: true, 
            keepWithHeaderRows: true,
            widths: ['*', '*'],
            body: [
              [{ text: 'Datos personales', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
              [{
                border: [true, false, false, true],
                stack: [
                  { text: 'Persona física', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDataUser,
                  },
                ]
              },
              {
                border: [false, false, true, true],
                stack: [
                  { text: 'Dirección del interesado', bold: true, style: 'bodyUser' },
                  {
                    type: 'none',
                    ol: this.bodyDirecciones,
                  },
                ]
              }],
            ]
          },
        },
        {
          text: ' ',
        },
        this.crearTablaRepresentante(),
        {
          text: ' ',
        },
        this.crearTablaPreguntas(),
        {
          text: ' ',
        },
        this.crearTablaUnidadFamiliar(),
        {
          text: ' ',
        },
        this.crearTablaDistritos(),
        {
          text: ' ',
        },
        this.crearTablaVulnerabilidad(),
        {
          text: ' ',
        },
        this.crearTablaFicheros(),
        {
          text: ' ',
        },
        this.crearTablaAutorizacion(),
        {
          text: ' ',
        },
        this.crearTablaConsulta(),

      ],
      footer: this.footer_definition,

      styles: {
        tableHeader: {
          fontSize: 14,
        },
        bodyUser: {
          fontSize: 9,
          marginTop: 2,
        }
      }
    }
  }

  public addlogo(): object {
    switch (environment.environment) {
      case 'emvs':
        return {
          image: imagenes.headerEmvs,
          width: 500,
        }

      default:
        return {
          text: ' ',
        };
    }
  }

  header_definition(currentPage, pageCount, pageSize) {
    return [{
      // margin: [31, 0, 31],
      // layout: {
      //   hLineColor: (i) => (i === 0) ? 'lightgray' : '',
      //   vLineWidth: (i) => 0,
      //   hLineWidth: (i) => (i === 0) ? 1 : 0
      // },
      // table: {
      //   widths: ['*'],
      //   body: [
      //     [
      //       { image: imagenes.headerEmvs },
      //     ]
      //   ]
      // }

      table: {
				widths: ['auto', "*", "auto"],
				body: [
					[
						{image: imagenes.headerEmvs},
						{text: 'Page ' + pageCount, alignment: 'center'},
						{text: 'Page ' + pageCount, alignment: 'right'}
					]
				]
			},
    }];
  };

  footer_definition(currentPage, pageCount, pageSize) {
    return [{
      margin: [31, 0, 31],
      layout: {
        hLineColor: (i) => (i === 0) ? 'lightgray' : '',
        vLineWidth: (i) => 0,
        hLineWidth: (i) => (i === 0) ? 1 : 0
      },
      table: {
        widths: ['*', 30],
        body: [
          [
            { text: 'Palos de la Frontera, 13. Madrid, 28012 - Telef. 915 16 81 50 www.oficinavirtual.emvs.es CIF: A-28740314', style: 'bodyUser', color: 'lightgray', alignment: 'center' },

            { text: `${currentPage}/${pageCount}`, style: 'bodyUser', color: 'lightgray', alignment: 'center' }
          ]
        ]
      }
    }];
  };

  public addCheck(): object {
    return {
      image: imagenes.check,
      width: 10
    }
  }

  public crearTablaUsuario(): void {

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Tipo de persona: ', bold: true, style: 'bodyUser' }, this.usuario["tipopersona"].nombre] })

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Nombre y Apellidos: ', bold: true, style: 'bodyUser' }, this.usuario["nombre"] + " " + this.usuario["apellido1"] + " " + this.usuario["apellido2"]] })

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Correo electrónico: ', bold: true, style: 'bodyUser' }, this.usuario["email"]] })

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Documento: ', bold: true, style: 'bodyUser' }, this.usuario["tipo_documento"].nombre, ' ', this.usuario["numero_documento"]] })

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Teléfono: ', bold: true, style: 'bodyUser' }, this.usuario["telefono"]] });

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Fecha de nacimiento: ', bold: true, style: 'bodyUser' }, this.usuario["fechaNacimiento"]] })

    this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Titulación: ', bold: true, style: 'bodyUser' }, this.usuario["titulacion"]] })

    if (this.usuario["genero"] != undefined) {
      this.bodyDataUser.push({ style: 'bodyUser', text: [{ text: 'Género: ', bold: true, style: 'bodyUser' }, this.usuario["genero"]] })
    }
  }


  public crearTablaDireccion(): void {

    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Tipo de vía: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].type_of_road.descripcion] })

    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Nombre y número de vía: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].name_road + " " + this.usuario['direcciones'][0].number_road] })

    if (this.usuario["direcciones"][0].block !== "" && this.usuario["direcciones"][0].block != null) {
      this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Bloque: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].block] })
    }

    if (this.usuario["direcciones"][0].stairs != "" && this.usuario["direcciones"][0].stairs != null) {
      this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Escalera: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].stairs] })
    }

    if (this.usuario["direcciones"][0].floor != "" && this.usuario["direcciones"][0].floor != null) {
      this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Piso: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].floor] })
    }

    if (this.usuario["direcciones"][0].door != "" && this.usuario["direcciones"][0].door != null) {
      this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Puerta: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].door] })
    }
    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Código postal: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].postal_code] })

    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Teléfono: ', bold: true, style: 'bodyUser' }, this.usuario['telefono']] })

    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'País: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].country.nombre] })

    this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Provincia: ', bold: true, style: 'bodyUser' }, this.usuario['direcciones'][0].province.nombre] })

    //this.bodyDirecciones.push({ style: 'bodyUser', text: [{ text: 'Municipio: ', bold: true, style: 'bodyUser' }, this.municipioNombre] })

  }


  public crearTablaPuestos(): object {
    var bodyPuestos: object[] = [];
    var columnaConvocatoria: object[] = [];
    var columnaDenominacion: object[] = [];
    var columnaDenominacionPuesto: object[] = [];


    for (var puesto of this.formularioPuestos.puesto) {
      columnaConvocatoria.push({ alignment: 'center', marginTop: 10, fontSize: 8, text: puesto.convocatoria });
      columnaDenominacion.push({ alignment: 'center', marginTop: 10, fontSize: 8, text: puesto.denominacion.nombre });
      columnaDenominacionPuesto.push({ alignment: 'center', marginTop: 10, fontSize: 8, text: puesto.denominacion.puesto });

    }

    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*', '*'],
        body: [
          [{ alignment: 'center', text: 'Convocatoria' }, { alignment: 'center', text: 'Denominación' }, { alignment: 'center', text: 'Puesto' }],
          [columnaConvocatoria, columnaDenominacion, columnaDenominacionPuesto]
        ]
      },
      layout: 'headerLineOnly'
    }
    bodyPuestos.push(tabla);
    bodyPuestos.push({ text: ' ', },);
    return bodyPuestos;
  }

  public crearTablaDocumentos(): object {
    var bodyDocumentos: object[] = [];

    bodyDocumentos.push({ style: 'bodyUser', text: [{ text: 'Curriculum: ', bold: true, style: 'bodyUser' }, this.formularioPuestos.documento.name?this.formularioPuestos.documento.name:this.formularioPuestos.documento] });
    bodyDocumentos.push({ style: 'bodyUser', text: [{ text: 'Titulación mínima requerida: ', bold: true, style: 'bodyUser' }, this.formularioPuestos.documento2.name?this.formularioPuestos.documento2.name:this.formularioPuestos.documento2] });

    return bodyDocumentos;
  }

  public crearTablaDocumentosAdjuntos(): object {
    var bodyDocumentos: object[] = [];
    if (this.mapDocumentos.length != 0) {
      for (var documento of this.mapDocumentos) {
        bodyDocumentos.push({ style: 'bodyUser', text: [{ text: 'Documento :', bold: true, style: 'bodyUser' }, documento.nameDocument] });
      }
      var tabla =
      {
        table: {
          headerRows: 1,
          dontBreakRows: true, 
          keepWithHeaderRows: true,
          widths: ['*'],
          body: [
            [{ text: 'Documentos adjuntos', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
            [{
              stack: bodyDocumentos

            }]
          ]
        },
      }

      return tabla;
    } else {
      return { text: "" }
    }
  }

  public crearTablaLopd(): string {
    return this.lopd;
  }

  public crearTablaUnidadFamiliar(): object {
    var columnaDocumento: object[] = [];
    var columnaDatos: object[] = [];
    var columnaFecha: object[] = [];
    var columnaParentesco: object[] = [];
    var columnaEstadoCivil: object[] = [];
    var columnaDiscapacidad: object[] = [];
    var columnaDependencia: object[] = [];


    for (var unidad of this.formUnidadFamiliar.familiar) {
      columnaDocumento.push({ style: 'bodyUser', text: unidad.documento });
      columnaDatos.push({ style: 'bodyUser', text: unidad.apellidos_nombre });
      columnaFecha.push({ style: 'bodyUser', text: unidad.fecha_nacimiento });
      columnaParentesco.push({ style: 'bodyUser', text: unidad.parentesco });
      columnaEstadoCivil.push({ style: 'bodyUser', text: unidad.estado_civil.nombre });
      columnaDiscapacidad.push({ style: 'bodyUser', text: unidad.grado_discapacidad.nombre });
      columnaDependencia.push({ style: 'bodyUser', text: unidad.grado_dependencia.nombre });
    }

    var tabla = {
      table: {
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        headerRows: 2,
        widths: ['*','*','*','*','*','*','*'],
        body: [
          [{ text: 'Datos de la unidad familiar solicitante', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white', colSpan:7},{},{},{},{},{},{}],
          [{ style: 'bodyUser', text: 'DNI/NIE' }, { style: 'bodyUser', text: 'APELLIDOS Y NOMBRE' }, { style: 'bodyUser', text: 'FECHA NACIMIENTO' }, { style: 'bodyUser', text: 'PARENTESCO' }, { style: 'bodyUser', text: 'ESTADO CIVIL' }, { style: 'bodyUser', text: 'GRADO DE DISCAPACIDAD' }, { style: 'bodyUser', text: 'GRADO DE DEPENDENCIA' }],
          [columnaDocumento, columnaDatos, columnaFecha, columnaParentesco, columnaEstadoCivil, columnaDiscapacidad, columnaDependencia]
        ]
      },
      layout: 'headerLineOnly'
    }
    return tabla;
  }

  public crearTablaRepresentante(): object {
    var bodyDocumentos: object[] = [];

    var provincia: string = "";
    if (this.formRepresentante.provincia_representado != null) {
      provincia = this.formRepresentante.provincia_representado.nombre;
    }
    // if (this.formRepresentante.documento_representado) {

    if (this.mapDocumentos.length != 0) {
      for (var documento of this.mapDocumentos) {
        bodyDocumentos.push({ style: 'bodyUser', text: [{ text: 'Documento :', bold: true, style: 'bodyUser' }, documento.nameDocument] });
      }
    }
    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*'],
        body: [
          [{ text: 'Información del representado', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
          [{
            border: [true, false, false, true],
            stack: [
              { text: 'Datos del representado', bold: true, style: 'bodyUser' },
              {
                type: 'none',
                ol: [
                  { style: 'bodyUser', text: [{ text: 'Nombre: ', bold: true, style: 'bodyUser' }, this.formRepresentante.nombre_representado] },
                  { style: 'bodyUser', text: [{ text: 'Apellidos: ', bold: true, style: 'bodyUser' }, this.formRepresentante.apellidos_representado] },
                  { style: 'bodyUser', text: [{ text: 'Documento: ', bold: true, style: 'bodyUser' }, this.formRepresentante.documento_representado] },
                  { style: 'bodyUser', text: [{ text: 'Dirección: ', bold: true, style: 'bodyUser' }, this.formRepresentante.direccion_representado] },
                  { style: 'bodyUser', text: [{ text: 'Código postal: ', bold: true, style: 'bodyUser' }, this.formRepresentante.cp_representado] },
                  { style: 'bodyUser', text: [{ text: 'Provincia: ', bold: true, style: 'bodyUser' }, provincia] },
                  { style: 'bodyUser', text: [{ text: 'Municipio: ', bold: true, style: 'bodyUser' }, this.formRepresentante.municipio_representado.nombre] },
                  { style: 'bodyUser', text: [{ text: 'Email: ', bold: true, style: 'bodyUser' }, this.formRepresentante.email_representado] },
                  { style: 'bodyUser', text: [{ text: 'Teléfono1: ', bold: true, style: 'bodyUser' }, this.formRepresentante.telefono1_representado] },
                  { style: 'bodyUser', text: [{ text: 'Teléfono2: ', bold: true, style: 'bodyUser' }, this.formRepresentante.telefono2_representado] },
                ],
              },
            ]
          },
          {
            border: [false, false, true, true],
            stack: [
              { text: 'Autorización expresa', bold: true, style: 'bodyUser' },
              {
                type: 'none',
                ol: [
                  { style: 'bodyUser', text: [{ text: 'D/Dª: ', bold: true, style: 'bodyUser' }, this.formRepresentante.nombre1_autorizacion] },
                  { style: 'bodyUser', text: [{ text: 'con DNI: ', bold: true, style: 'bodyUser' }, this.formRepresentante.dni1_autorizacion] },
                  { style: 'bodyUser', text: [{ text: 'autoriza a D/Dª: ', bold: true, style: 'bodyUser' }, this.formRepresentante.nombre2_autorizacion] },
                  { style: 'bodyUser', text: [{ text: 'con DNI: ', bold: true, style: 'bodyUser' }, this.formRepresentante.dni2_autorizacion] },
                  { style: 'bodyUser', text: [{ text: 'Se adjuntan los siguientes documentos: ', bold: true, style: 'bodyUser' }] },
                  [{ stack: bodyDocumentos }]
                ],
              },
            ]
          }],
        ]
      },
    }

    return tabla;
    // } else {

    //   return { text: "" }
    // }
  }

  public crearTablaRepresentanteReducido(): object {
    var tipoVia: string = "";
    var provincia: string = "";

    if (this.formRepresentanteReducido.tipo_via_representado != null) {
      tipoVia = this.formRepresentanteReducido.tipo_via_representado.descripcion;
    }

    if (this.formRepresentanteReducido.provincia_representado != null) {
      provincia = this.formRepresentanteReducido.provincia_representado.nombre;
    }

    // if (this.formRepresentanteReducido.documento_representado) {

    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*'],
        body: [
          [{ text: 'Datos representante', style: 'tableHeader', colSpan: 2, alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
          [{
            border: [true, false, false, true],
            stack: [
              { text: 'Datos del representante', bold: true, style: 'bodyUser' },
              {
                type: 'none',
                ol: [
                  { style: 'bodyUser', text: [{ text: 'Apellidos: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.apellidos_representado] },
                  { style: 'bodyUser', text: [{ text: 'Nombre: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.nombre_representado] },
                  { style: 'bodyUser', text: [{ text: 'Documento: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.documento_representado] },
                  { style: 'bodyUser', text: [{ text: 'Género: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.genero_representado] },
                  { style: 'bodyUser', text: [{ text: 'Correo electrónico: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.email_representado] },
                  { style: 'bodyUser', text: [{ text: 'Teléfono1: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.telefono1_representado] },
                  { style: 'bodyUser', text: [{ text: 'Teléfono2: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.telefono2_representado] },
                ],
              },
            ]
          },
          {
            border: [false, false, true, true],
            stack: [
              { text: 'Dirección del representante', bold: true, style: 'bodyUser' },
              {
                type: 'none',
                ol: [
                  { style: 'bodyUser', text: [{ text: 'Tipo de vía: ', bold: true, style: 'bodyUser' }, tipoVia] },
                  { style: 'bodyUser', text: [{ text: 'Nombre y número de vía: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.direccion_representado + " " + this.formRepresentanteReducido.numero_calle_representado] },
                  { style: 'bodyUser', text: [{ text: 'Portal: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.portal_representado] },
                  { style: 'bodyUser', text: [{ text: 'Escalera: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.escalera_representado] },
                  { style: 'bodyUser', text: [{ text: 'Piso: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.planta_representado] },
                  { style: 'bodyUser', text: [{ text: 'Puerta: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.puerta_representado] },
                  { style: 'bodyUser', text: [{ text: 'Código postal: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.cp_representado] },
                  { style: 'bodyUser', text: [{ text: 'Provincia: ', bold: true, style: 'bodyUser' }, provincia] },
                  { style: 'bodyUser', text: [{ text: 'Localidad: ', bold: true, style: 'bodyUser' }, this.formRepresentanteReducido.municipio_representado.nombre] },
                ],
              },
            ]
          }],
        ]
      },
    }

    return tabla;
    // } else {
    //   return { text: "" }
    // }
  }

  public crearTablaPreguntas(): object {
    var columnaPreguntas: object = {
      type: 'none',
      ul: [
        { style: 'bodyUser', text: [{ text: '¿Acredita residencia en el municipio de Madrid de al menos 1 año ininterrumpido? (código postal entre 28000 y 28099)  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta1] },
        { style: 'bodyUser', text: [{ text: 'En caso de no acreditar empadronamiento, ¿desarrolla su actividad laboral en el municipio de Madrid en los 2 últimos años?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta2] },
        { style: 'bodyUser', text: [{ text: 'Usted, o algún miembro de su unidad familiar, ¿tiene una discapacidad con movilidad reducida permanente y necesita vivienda adaptada?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta3] },
        { style: 'bodyUser', text: [{ text: 'Si la pregunta anterior es afirmativa, ¿tiene necesidad de ayuda de tercera persona?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta4] },
        { style: 'bodyUser', text: [{ text: '¿Tiene usted título de Familia Numerosa en vigor?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta5] },
        { style: 'bodyUser', text: [{ text: '¿Es usted una familia monoparental? (Padre o madre que no convive en pareja con hijos menores de edad, empadronados juntos)', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta6] },
        { style: 'bodyUser', text: [{ text: '¿Tiene usted vivienda en propiedad, independientemente del título o porcentaje sobre la misma? (compra, herencia, donación, etc.)  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta7] },
        { style: 'bodyUser', text: [{ text: '¿Es usted arrendatario/a de una vivienda en propiedad o gestionada por EMVS Madrid o por cualquier otra administración o entidad pública?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta8] },
        { style: 'bodyUser', text: [{ text: '¿Es usted víctima (directa o indirecta) de violencia de género, trata y/o explotación sexual?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta9] },
        { style: 'bodyUser', text: [{ text: '¿Acredita condición de refugiado/a?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta10] },
        { style: 'bodyUser', text: [{ text: '¿Se encuentra actualmente ocupando una vivienda inmueble de EMVS Madrid o del Ayuntamiento de Madrid sin título legítimo para ello?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta11] },
        { style: 'bodyUser', text: [{ text: '¿Ha sido lanzado judicialmente por ocupación de una vivienda de titularidad o gestión de EMVS Madrid o del Ayuntamiento de Madrid?  ', bold: true, style: 'bodyUser' }, this.formCircunstancias.pregunta12] },
      ]
    }

    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*'],
        body: [
          [{ text: 'Circustancias económicas, familiares y personales', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
          [columnaPreguntas]
        ]
      },
    }
    return tabla;
  }

  public crearTablaDistritos(): object {
    var todas_zonas: string = '';
    var tabla = {};

    if (this.formDistritos.todas_zonas === true) {
      todas_zonas = 'Sí';
      tabla = {
        table: {  
          dontBreakRows: true, 
          keepWithHeaderRows: true,
          headerRows: 2,
          widths: ['*', '*'],
          body: [
            [{ text: 'Distritos municipales', colSpan: 2, style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
            [{ text: 'Todas las Zonas', style: 'tableHeader', alignment: 'center', fillColor: '#8b99a3', color: 'white' }, { text: todas_zonas }],
          ]
        },
      }
    } else {
      todas_zonas = 'No';
      tabla = {
        table: {
          dontBreakRows: true, 
          keepWithHeaderRows: true,
          headerRows: 2,
          widths: ['*', '*'],
          body: [
            [{ text: 'Distritos municipales', colSpan: 2, style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
            [{ text: 'Todas las Zonas', style: 'tableHeader', alignment: 'center', fillColor: '#8b99a3', color: 'white' }, { text: todas_zonas }],
            [{ text: '1. Centro' }, { text: this.formDistritos.centro }],
            [{ text: '2. Arganzuela' }, { text: this.formDistritos.arganzuela }],
            [{ text: '3. Retiro' }, { text: this.formDistritos.retiro }],
            [{ text: '4. Salamanca' }, { text: this.formDistritos.salamanca }],
            [{ text: '5. Chamartín' }, { text: this.formDistritos.chamartin }],
            [{ text: '6. Tetuán' }, { text: this.formDistritos.tetuan }],
            [{ text: '7. Chamberí' }, { text: this.formDistritos.chamberi }],
            [{ text: '8. Fuencarral-El Pardo' }, { text: this.formDistritos.fuencarral_pardo }],
            [{ text: '9. Moncloa' }, { text: this.formDistritos.moncloa }],
            [{ text: '10. Latina' }, { text: this.formDistritos.latina }],
            [{ text: '11. Carabanchel' }, { text: this.formDistritos.carabanchel }],
            [{ text: '12. Usera' }, { text: this.formDistritos.usera }],
            [{ text: '13. Puente de Vallecas' }, { text: this.formDistritos.puente_vallecas }],
            [{ text: '14. Moratalaz' }, { text: this.formDistritos.moratalaz }],
            [{ text: '15. Ciudad lineal' }, { text: this.formDistritos.ciudad_lineal }],
            [{ text: '16. Hortaleza' }, { text: this.formDistritos.hortaleza }],
            [{ text: '17. Villaverde' }, { text: this.formDistritos.villaverde }],
            [{ text: '18. Vallecas villa' }, { text: this.formDistritos.vallecas_villa }],
            [{ text: '19. Vicálvaro' }, { text: this.formDistritos.vilcalvaro }],
            [{ text: '20. San Blas' }, { text: this.formDistritos.san_blas }],
            [{ text: '21. Barajas' }, { text: this.formDistritos.barajas }],
          ]
        },
      }
    }

    return tabla;
  }

  public crearTablaVulnerabilidad(): object {
    var columnaPreguntas: object = {
      type: 'none',
      ul: [
        { style: 'bodyUser', text: [{ text: '1. ¿En qué tipo de alojamiento reside?  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta1] },
        { style: 'bodyUser', text: [{ text: '2. La situación de la vivienda donde reside:  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta2] },
        { style: 'bodyUser', text: [{ text: '3. La vivienda donde reside, ¿tiene problemas de accesibilidad o impedimentos físicos para sus necesidades?  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta3] },
        { style: 'bodyUser', text: [{ text: '4. La vivienda donde reside, ¿se encuentra en situación de riesgo de perderla?  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta4] },
        { style: 'bodyUser', text: [{ text: '5. La vivienda donde reside, por las dimensiones de la misma, ¿es adecuada para su unidad convivencial?  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta5] },
        { style: 'bodyUser', text: [{ text: '6. La vivienda donde reside, ¿se encuentra en adecuadas condiciones de habitabilidad?  ', bold: true, style: 'bodyUser' }, this.formVulnerabilidad.pregunta6] },
      ]
    }

    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*'],
        body: [
          [{ text: 'Situación de vulnerabilidad residencial', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }],
          [columnaPreguntas]
        ]
      },
    }
    return tabla;
  }

  public crearTablaFicheros(): object {
    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*'],
        body: [
          [{ text: 'Carga de ficheros', colSpan: 2, style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],

          [{ text: '1. La documentación de carácter general:', colSpan: 2, alignment: 'center' }, {}],
          [{ style: 'bodyUser', text: 'DNI/NIE/Certificado de Registro de Ciudadano de la UE (solo en el caso de no autorizarnos a consultar tus datos)' }, { text: this.formFicheros.find((object) => object.key == 'dni_nie') != null ? this.formFicheros.find(object => object.key == 'dni_nie').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Libro de Familia, en su defecto, Certificado de matrimonio, certificado de nacimiento según proceda' }, { text: this.formFicheros.find((object) => object.key == 'libro_familia') != null ? this.formFicheros.find(object => object.key == 'libro_familia').nameDocument : '' }],
          [{ text: '2. Según tu caso, el resto de documentación necesaria:', colSpan: 2, alignment: 'center' }, {}],
          [{ style: 'bodyUser', text: 'Persona separada o divorciada: Testimonio Judicial de Sentencia firme' }, { text: this.formFicheros.find((object) => object.key == 'separada') != null ? this.formFicheros.find(object => object.key == 'separada').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Familia monoparental: Testimonio judicial de ostentar la guarda y custodia de hijos menores' }, { text: this.formFicheros.find((object) => object.key == 'monoparental') != null ? this.formFicheros.find(object => object.key == 'monoparental').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Familia numerosa: Título de familia numerosa en vigor (solo en el caso de no autorizarnos a consultar tus datos)' }, { text: this.formFicheros.find((object) => object.key == 'familia_numerosa') != null ? this.formFicheros.find(object => object.key == 'familia_numerosa').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Si no acreditas 1 año de residencia en el Municipio de Madrid: Certificado de Vida Laboral actual' }, { text: this.formFicheros.find((object) => object.key == 'vida_laboral') != null ? this.formFicheros.find(object => object.key == 'vida_laboral').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Si no acreditas 1 año de residencia en el Municipio de Madrid: Certificado de trabajador por cuenta ajena, propia o funcionario público' }, { text: this.formFicheros.find((object) => object.key == 'funcionario') != null ? this.formFicheros.find(object => object.key == 'funcionario').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Movilidad reducida: Certificado de necesidad de vivienda adaptada' }, { text: this.formFicheros.find((object) => object.key == 'movilidad_reducida') != null ? this.formFicheros.find(object => object.key == 'movilidad_reducida').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Discapacidad: Certificado acreditativo del grado de discapacidad y/o dependencia' }, { text: this.formFicheros.find((object) => object.key == 'discapacidad') != null ? this.formFicheros.find(object => object.key == 'discapacidad').nameDocument : '' }],
          [{ text: '3. Si quieres enviar otra documentación:', colSpan: 2, alignment: 'center' }, {}],
          [{ style: 'bodyUser', text: 'Archivo 1:' }, { text: this.formFicheros.find(object => object.key == 'archivo1') != null ? this.formFicheros.find(object => object.key == 'archivo1').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Archivo 2:' }, { text: this.formFicheros.find(object => object.key == 'archivo2') != null ? this.formFicheros.find(object => object.key == 'archivo2').nameDocument : '' }],
          [{ style: 'bodyUser', text: 'Archivo 3:' }, { text: this.formFicheros.find(object => object.key == 'archivo3') != null ? this.formFicheros.find(object => object.key == 'archivo3').nameDocument : '' }],
        ]
      },
    }
    return tabla;
  }

  public crearTablaAutorizacion(): object {
    var columnaDocumento: object[] = [];
    var columnaDatos: object[] = [];
    var columnaFecha: object[] = [];
    var columnaParentesco: object[] = [];
    var columnaEstadoCivil: object[] = [];


    for (var auto of this.formAutorizacion.autorizacion) {
      columnaDocumento.push({ style: 'bodyUser', text: auto.documento });
      columnaDatos.push({ style: 'bodyUser', text: auto.apellidos_nombre });
      columnaFecha.push({ style: 'bodyUser', text: auto.fecha_nacimiento });
      columnaParentesco.push({ style: 'bodyUser', text: auto.parentesco });
      columnaEstadoCivil.push({ style: 'bodyUser', text: auto.estado_civil.nombre });
    }

    var tabla = {
      table: {
        headerRows: 2,
        widths: ['*', '*', '*', '*', '*'],
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        body: [
          [{ text: 'Autorización de consulta de datos a administraciones y organismos públicos', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white', colSpan:5 },{},{},{},{}],
          [{ style: 'bodyUser', text: 'DNI/NIE' }, { style: 'bodyUser', text: 'APELLIDOS Y NOMBRE' }, { style: 'bodyUser', text: 'FECHA NACIMIENTO' }, { style: 'bodyUser', text: 'PARENTESCO' }, { style: 'bodyUser', text: 'ESTADO CIVIL' }],
          [columnaDocumento, columnaDatos, columnaFecha, columnaParentesco, columnaEstadoCivil]
        ]
      },
      layout: 'headerLineOnly'
    }
    return tabla;
  }

  public crearTablaConsulta(): object {
    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*'],
        body: [
          [{ text: 'Consulta de datos de la unidad familiar solicitante', colSpan: 2, style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white' }, {}],
          [{
            table: {
              body: [
                [{ text: '' }, {}],
                [{ text: 'A) EN CASO DE AUTORIZAR A EMVS Madrid LA CONSULTA DE DATOS ANTE LOS ÓRGANOS PERTINENTES:', colSpan: 2 }, {}],
                [{ text: 'NO MARCAR NINGUNA CASILLA', colSpan: 2, alignment: 'center' }, {}],
                [{ text: '' }, {}],
                [{ text: 'B) EN CASO DE NO AUTORIZAR A EMVS Madrid A REALIZAR LA CONSULTA:', colSpan: 2 }, {}],
                [{ text: 'SE COMPROMETE A APORTAR LA DOCUMENTACIÓN CORRESPONDIENTE A LAS CASILLAS MARCADAS' }, {}],
                [{ text: '' }, {}],

                [{ style: 'bodyUser', text: 'DNI/NIE' }, this.formConsulta.dni_nie == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Certificado del IRPF o certificado de Imputaciones y/o pensiones públicas exentas:' }, this.formConsulta.certificado_irpf == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Prestaciones sociales públicas , Incapacidad Temporal y Maternidad' }, this.formConsulta.prestaciones_sociales == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Familia Numerosa' }, this.formConsulta.familia_numerosa == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Discapacidad y/o Dependencia' }, this.formConsulta.discapacidad_dependencia == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Titularidad Inmuebles y/o Nota Simple' }, this.formConsulta.titularidad_inmuebles == true ? this.addCheck() : {}],
                [{ style: 'bodyUser', text: 'Empadronamiento' }, this.formConsulta.empadronamiento == true ? this.addCheck() : {}],
              ]
            },
            layout: 'noBorders', colSpan: 2
          }, {}]]
      },
    }
    return tabla;
  }

  crearTablaExponeSolicita(): object {
    var tabla = {
      table: {
        headerRows: 1,
        dontBreakRows: true, 
        keepWithHeaderRows: true,
        widths: ['*', '*'],
        body: [
          [{ text: 'Datos Solicitud', style: 'tableHeader', alignment: 'center', fillColor: '#699EC5', color: 'white', colSpan: 2 }, {}],
          [{
            border: [true, false, false, true],
            stack: [
              { text: 'Expone', bold: true, style: 'bodyUser', alignment: 'center' },
              {
                table: {
                  headerRows: 1,
                  widths: ['*'],
                  border: [true, true, true, true],
                  body: [
                    [{ style: 'bodyUser', text: this.formExponeSolicita.expone }]
                  ]
                }
              },
            ]
          },
          {
            border: [false, false, true, true],
            stack: [
              { text: 'Solicita', bold: true, style: 'bodyUser', alignment: 'center' },
              {
                table: {
                  headerRows: 1,
                  widths: ['*'],
                  border: [true, true, true, true],
                  body: [
                    [{ style: 'bodyUser', text: this.formExponeSolicita.solicita }]
                  ]
                }
              },
            ]
          }]
        ]
      },
    }
    return tabla;
  }
}
